import React from "react";
import Snackbar from "@mui/material/Snackbar";
import { SnackbarContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"; // 👈 Import Close Icon

interface CommonSnackbarProps {
  open: boolean;
  message: string;
  onClose: () => void;
  backgroundColor?: string;
  classes?: string;
  autoHideDuration?: number;
}

const CommonSnackbar: React.FC<CommonSnackbarProps> = ({
  open,
  message,
  onClose,
  backgroundColor,
  classes,
  autoHideDuration = 2000,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      disableWindowBlurListener
    >
      <SnackbarContent
        className={classes}
        style={{ backgroundColor }}
        message={message}
        action={(
          <IconButton size="small" aria-label="close" color="inherit" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      />
    </Snackbar>
  );
};

export default CommonSnackbar;